import { SIZES } from '../theme/media-queries'
import { useMediaQuery } from '@dtx-company/true-common/src/hooks/useMediaQuery'

/**
 * @deprecated use [useScreenSizeBreakpoints](apps/app/shared/common/src/hooks/useScreenSizeBreakpoints.ts) instead
 */
export const useIsMobileOrTablet = (): boolean => {
  return useMediaQuery(`(max-width: ${SIZES.desktop - 1}px)`)
}
